import { render, staticRenderFns } from "./AdditionalFields.vue?vue&type=template&id=1d9d0281"
import script from "./AdditionalFields.vue?vue&type=script&lang=js"
export * from "./AdditionalFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports